// @packages
import { StatusBar } from 'expo-status-bar';
import React from 'react';
import { View } from 'react-native';

// @scripts
import ForgotPasswordSubmit from '../../components/organisms/forgot-password-recovery-password';
import useStyles from './styles';

const ForgotPasswordSendRecovery = () => {
  const styles = useStyles();
  return (
    <View style={styles.container}>
      <ForgotPasswordSubmit />
      <StatusBar style="auto" />
    </View>
  );
};

export default ForgotPasswordSendRecovery;
